import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ContratoItemInterface } from 'app/module/contrato-item-interface';

@Injectable({
	providedIn: 'root'
})
export class ContratoItemService {
	private url: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}

	constructor(private http: HttpClient) { }

	// public get(): Observable<ContratoItemInterface[]> {
	// 	return this.http.get<ContratoItemInterface[]>(`${this.url}pedido`, this.httpOptions).pipe(
	// 		(res) => res,
	// 		(error) => error
	// 	);
	// }

	public findOneByContratoId(id: number): Observable<ContratoItemInterface[]> {
		return this.http.get<ContratoItemInterface[]>(`${this.url}contrato-itens/contrato/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public post(data: any): Observable<any> {
		return this.http
			.post<any>(`${this.url}contrato-itens/create`, data, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	// public put(data: any, id: number): Observable<any> {
	// 	return this.http
	// 		.put<any>(`${this.url}pedido/${id}`, {
	// 			id_cliente: data.id_cliente,
	// 		}, this.httpOptions)
	// 		.pipe(
	// 			(res) => res,
	// 			(error) => error
	// 		);
	// }

	// public delete(data: number, id: number): Observable<any> {
	// 	return this.http
	// 		.put<any>(`${this.url}sistema/${id}/update`, this.httpOptions, {
	// 			id_sistema: id,
	// 			isDeleted: data,
	// 		})
	// 		.pipe(
	// 			(res) => res,
	// 			(error) => error
	// 		);
	// }
}
